@if (includeHeader) {
  <div class="dialog-header" [ngClass]="{ 'dark-theme': dialogType === 'primary' }" nhaTest="dialog-header">
    <div class="title">
      @if (titleIcon) {
        <mat-icon class="title-icon">{{ titleIcon }}</mat-icon>
      }
      <ng-content select="[dialog-title]"></ng-content>
      <ng-content select="[dialog-subtitle]"></ng-content>
    </div>
    <ng-content select="[dialog-header]"></ng-content>
    @if (notes) {
      <ul class="dialog-notes">
        @for (note of notes; track note) {
          <li>{{ note }}</li>
        }
      </ul>
    }
    <ng-content select="[dialog-header-action-area]"></ng-content>
  </div>
}

@if (hasTabs) {
  <div class="tabs-area">
    <ng-content select="[dialog-tabs]"></ng-content>
  </div>
}

<div class="dialog-content" nhaTest="dialog-content">
  <ng-content select="[dialog-content-action-bar]"></ng-content>
  @if (hasPanel) {
    <ng-content select="[dialog-content-panel]"></ng-content>
  }
  <ng-content select="[dialog-content]"></ng-content>
</div>

@if (includeFooter) {
  <div class="dialog-footer" nhaTest="dialog-footer">
    <ng-content select="[dialog-footer]"></ng-content>
  </div>
}
